// extracted by mini-css-extract-plugin
export default {"container":"UserManagementPage_container__O3lpF","table":"UserManagementPage_table__jmCi7","iconButtonsContainer":"UserManagementPage_iconButtonsContainer__sWI6w"};